import React from 'react';

import CardDialog from '~/components/CardDialog';
import { Heading } from '~/components/core';
import OperationsBreadcrumbs from '~/components/SystemConfiguration/OperationsBreadcrumbs';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import useDataFetcher from '~/components/useDataFetcher';
import type { SnapshotListResponse } from '~/server_shared/openapi/data-contracts';

import CreateSnapshotContainer from './CreateSnapshotContainer';
import SnapshotsList from './SnapshotsList';

const ConfigurationSnapshots: React.FC = () => {
  // @ts-expect-error TODO: useSysconfig hook needs TypeScript definition
  const { organization } = useSysconfig();

  const {
    data: snapshotsData,
    reloadData: reloadSnapshots,
    isLoading,
  } = useDataFetcher<SnapshotListResponse>(
    `/sysconfig/api/v1/configuration_repository/organizations/${organization.id}/snapshots`
  );

  return (
    <CardDialog noCardTitle>
      <OperationsBreadcrumbs currentTab="Snapshots & Backup" />
      <div className="grid grid-cols-2 items-center">
        <Heading className="mt-20">Configuration Snapshots</Heading>
        <CreateSnapshotContainer className="justify-self-end" onSuccess={reloadSnapshots} />
      </div>
      <SnapshotsList snapshotsData={snapshotsData} onRefresh={reloadSnapshots} isLoading={isLoading} />
    </CardDialog>
  );
};

export default ConfigurationSnapshots;
